module.exports = __webpack_public_path__ + "static/img/product-list.f794181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/product-list.png
// module id = YdTu
// module chunks = 26